export const EMAIL_REGEXP = /\S+@\S+\.\S+/